var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIconRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 85,
    viewBox: "0 0 117 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7666 51.8194C69.1547 51.8194 73.5225 47.4515 73.5225 42.0635C73.5225 36.6754 69.1547 32.3076 63.7666 32.3076C58.3786 32.3076 54.0107 36.6754 54.0107 42.0635C54.0107 47.4515 58.3786 51.8194 63.7666 51.8194Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7613 51.8194C42.1493 51.8194 46.5172 47.4515 46.5172 42.0635C46.5172 36.6754 42.1493 32.3076 36.7613 32.3076C31.3732 32.3076 27.0054 36.6754 27.0054 42.0635C27.0054 47.4515 31.3732 51.8194 36.7613 51.8194Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7559 51.8194C15.1439 51.8194 19.5118 47.4515 19.5118 42.0635C19.5118 36.6754 15.1439 32.3076 9.7559 32.3076C4.36786 32.3076 0 36.6754 0 42.0635C0 47.4515 4.36786 51.8194 9.7559 51.8194Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2504 84.0562C69.8467 84.0562 67.4431 83.0665 65.605 81.2284C61.9289 77.5523 61.9289 71.6139 65.605 67.7964L91.338 42.0635L65.4636 16.1891C61.7875 12.513 61.7875 6.57463 65.4636 2.7571C69.1398 -0.919034 75.0781 -0.919034 78.8957 2.7571L116.364 40.2254C117.212 41.0737 117.212 42.629 116.364 43.4774L78.8957 81.2284C77.0576 83.0665 74.654 84.0562 72.2504 84.0562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconRight);
export default __webpack_public_path__ + "static/media/ArrowIconRight.7cdaaa9949350dc44c0aa9b87ced2836.svg";
export { ForwardRef as ReactComponent };